import { api } from '../config/api';
import { ExpenseTag } from './expenseTags.service';

export interface Expense {
  id: number;
  property_id: number;
  category_id?: number;
  document_id?: number;
  amount: number;
  expense_date: string;
  vendor?: string;
  description?: string;
  approved_by?: number;
  approved_at?: string;
  created_at: string;
  updated_at?: string;
  property?: any;
  category?: any;
  document?: any;
  tags?: ExpenseTag[];
  property_name?: string;
  category_name?: string;
}

export interface CreateExpenseData {
  property_id?: number;
  category_id?: number;
  document_id?: number | string;
  amount: number;
  expense_date: string;
  vendor?: string;
  description?: string;
}

export interface UpdateExpenseData {
  category_id?: number;
  amount?: number;
  expense_date?: string;
  vendor?: string;
  description?: string;
}

class ExpensesService {
  async getExpenses(propertyId?: number, tagIds?: number[]): Promise<Expense[]> {
    const params: any = {};
    if (propertyId) params.property_id = propertyId;
    if (tagIds?.length) params.tag_ids = tagIds;
    
    console.log('Fetching expenses with params:', params);
    const response = await api.get('/expenses/', { params });
    console.log('Expenses API response:', response.data);
    return response.data;
  }

  async getExpense(id: number): Promise<Expense> {
    const response = await api.get(`/expenses/${id}`);
    return response.data;
  }

  async createExpense(data: CreateExpenseData): Promise<Expense> {
    console.log('ExpensesService.createExpense called with data:', data);
    console.log('About to make API call to POST /expenses/');
    try {
      const response = await api.post('/expenses/', data);
      console.log('API response received:', response);
      console.log('Response status:', response.status);
      console.log('Response data:', response.data);
      return response.data;
    } catch (error) {
      console.error('API call failed in ExpensesService.createExpense:', error);
      console.error('Error response:', (error as any).response);
      console.error('Error response data:', (error as any).response?.data);
      console.error('Error response status:', (error as any).response?.status);
      throw error;
    }
  }

  async updateExpense(id: number, data: UpdateExpenseData): Promise<Expense> {
    const response = await api.put(`/expenses/${id}`, data);
    return response.data;
  }

  async deleteExpense(id: number): Promise<void> {
    await api.delete(`/expenses/${id}`);
  }
}

export const expensesService = new ExpensesService();